// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var GoogleApis__Sheets__BatchUpdate$SmartcutsMacros = require("./GoogleApis__Sheets__BatchUpdate.bs.js");
var GoogleApis__Sheets__DeveloperMetadata$SmartcutsMacros = require("./GoogleApis__Sheets__DeveloperMetadata.bs.js");

function load(param) {
  return new Promise((function (resolve, param) {
                gapi.client.load("sheets", "v4", (function (param) {
                        var client = gapi.client.sheets;
                        return resolve(client);
                      }));
                
              }));
}

var Create = {};

function create(accessToken, alt, callback, fields, key, oauthToken, prettyPrint, quotaUser, uploadProtocol, uploadType, resource, client) {
  return client.spreadsheets.create({
                access_token: accessToken,
                alt: alt,
                callback: callback,
                fields: fields,
                key: key,
                oauth_token: oauthToken,
                prettyPrint: prettyPrint,
                quotaUser: quotaUser,
                upload_protocol: uploadProtocol,
                uploadType: uploadType,
                resource: resource
              }).then(function (param) {
              return Promise.resolve(param.result);
            });
}

var Get = {};

function get(accessToken, alt, callback, fields, includeGridData, key, oauthToken, prettyPrint, quotaUser, ranges, spreadsheetId, uploadProtocol, uploadType, client) {
  return client.spreadsheets.get({
                access_token: accessToken,
                alt: alt,
                callback: callback,
                fields: fields,
                includeGridData: includeGridData,
                key: key,
                oauth_token: oauthToken,
                prettyPrint: prettyPrint,
                quotaUser: quotaUser,
                ranges: ranges,
                spreadsheetId: spreadsheetId,
                upload_protocol: uploadProtocol,
                uploadType: uploadType
              }).then(function (param) {
              return Promise.resolve(param.result);
            });
}

var BatchUpdate = GoogleApis__Sheets__BatchUpdate$SmartcutsMacros;

function batchUpdate(spreadsheetId, accessToken, requestBody, client) {
  return client.spreadsheets.batchUpdate({
                access_token: accessToken,
                spreadsheetId: spreadsheetId
              }, requestBody).then(function (param) {
              return Promise.resolve(param.result);
            });
}

var DeveloperMetadata = GoogleApis__Sheets__DeveloperMetadata$SmartcutsMacros;

function searchDeveloperMetadata(spreadsheetId, accessToken, requestBody, client) {
  return client.spreadsheets.developerMetadata.search({
                access_token: accessToken,
                spreadsheetId: spreadsheetId
              }, requestBody).then(function (param) {
              return Promise.resolve(param.result);
            });
}

var Shared;

var Schema;

var Values;

exports.Shared = Shared;
exports.load = load;
exports.Schema = Schema;
exports.Create = Create;
exports.create = create;
exports.Get = Get;
exports.get = get;
exports.Values = Values;
exports.BatchUpdate = BatchUpdate;
exports.batchUpdate = batchUpdate;
exports.DeveloperMetadata = DeveloperMetadata;
exports.searchDeveloperMetadata = searchDeveloperMetadata;
/* GoogleApis__Sheets__BatchUpdate-SmartcutsMacros Not a pure module */
